import React from 'react';
import cn from 'classnames';
import Cropper from 'react-easy-crop';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { Client, Auth, Uploader } from 'services/action';
import { Page, Form, Button, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';
import getCroppedImg from 'utilities/crop.image';

const initialOptions = [
  { value: 'carrier', label: 'Carrier' },
  { value: 'shipper', label: 'Shipper' },
];

const OnboardingScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Client.Show']
  );
  const Session = useSelector((state) => state.Auth?.session);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const refs = React.useRef(null);

  const [data, setData] = React.useState(null);
  const [image, setImage] = React.useState();
  const [village, setVillage] = React.useState(null);

  const [isShow, setIsShow] = React.useState(false);
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [rotation, setRotation] = React.useState(0);
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);
  const [croppedImage, setCroppedImage] = React.useState(null);
  const [useBackground, setUseBackground] = React.useState(false);
  const [imageEdit, setImageEdit] = React.useState();

  const $onLoad = async (e) => {
    const req = await Dispatch(Client.$show(e));

    if (req?.message === 'success' && req?.data) {
      var d = req?.data
      d.company_type = req?.data?.company_type === 'carrier' ? initialOptions[0]: initialOptions[1]

      setData(d);
      setImage(req?.data?.avatar);
      setVillage(req?.data?.region);
    }
  };

  const onCropComplete = React.useCallback(
    async (croppedArea, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  const showCroppedImage = React.useCallback(
    async (v) => {
      try {
        const croppedImage = await getCroppedImg(
          image,
          croppedAreaPixels,
          rotation,
          v
        );
        setCroppedImage(croppedImage);
        setImageEdit(croppedImage);
      } catch (e) {
        console.error(e);
      }
    },
    [croppedAreaPixels, rotation, useBackground, image]
  );

  const $handleBackground = async (e) => {
    setUseBackground(e);
    showCroppedImage(e);
  };

  const imgToBase64 = (blob) => {
    let reader = new FileReader();

    reader.readAsDataURL(blob);

    reader.onload = function () {
      setImage(reader.result);
    };
  };

  const $handleClose = () => {
    setIsShow(false);
  };

  const $handleSubmit = async (c) => {
    const payload = {
      ...data,
      village_id: village ? village?.village_id : '',
      company_type: data?.company_type?.value || ''
    };

    if (croppedImage) {
       const post = await Dispatch(Uploader.$upload({ file: croppedImage }));

      if (post?.message === 'success') {
        payload.avatar = post?.data;
      }
    }

    const submit = await Dispatch(Client.$update(data?.id, payload));

    if (submit?.message === 'success') {
      Dispatch(Auth.$fetchProfile());
      History.push('/onboarding-hub');
    }
  };

  React.useEffect(() => {
    $onLoad(Session?.user?.id);
  }, []);

  return (
    <Page
      type="form"
      className="col-12 p-md-4 bg-white h-100"
      onSubmit={$handleSubmit}
      isOnboarding
    >
      <Page.Header
        isOnboarding={
          <div className="py-3 px-0 mt-5 mt-md-0">
            <div
              className="fw-semibold title mb-2 p-0"
              style={{ fontSize: 26 }}
            >
              Profil Perusahaan
            </div>
            <div className="page-pretitle fw-normal" style={{ fontSize: 12 }}>
              Welcome to envio logistics
            </div>
          </div>
        }
        className="p-0"
      />
      <Page.Body className="p-md-3 px-3 mt-4 mt-md-0">
        {StateLoading ? (
          <div className="row">
            <div className="col-12 pt-3">
              {dummy?.map((d, i) => (
                <SkeletonsForm count={1} key={i} />
              ))}
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-12 pt-3">
              <div className="mb-3">
                <label className='form-label required'>Pilih Tipe Perusahaan</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.pricing_schema ? 'is-invalid' : 'select'
                  }
                  placeholder=""
                  value={data?.company_type}
                  options={initialOptions}
                  onChange={(e) =>
                    setData({ ...data, company_type: e })
                  }
                  error={StateForm?.errors?.company_type}
                />

                {StateForm?.errors?.company_type ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.company_type}
                  </div>
                ) : null}
              </div>

              <Form.Input
                label="Nama Perusahaan"
                required
                type="text"
                value={data?.company_name || ''}
                onChange={(e) =>
                  setData({ ...data, company_name: e.target.value })
                }
                error={StateForm?.errors?.company_name}
              />

              <Form.Input
                label="Nama Penanggung Jawab"
                required
                type="text"
                value={data?.name || ''}
                onChange={(e) =>
                  setData({ ...data, name: e.target.value })
                }
                error={StateForm?.errors?.name}
              />

              <Form.Input
                label="No. Handphone Penanggung Jawab"
                required
                type="phone"
                value={data?.phone || ''}
                onChange={(e) => setData({ ...data, phone: e.target.value })}
                error={StateForm?.errors?.phone}
              />

              <Form.Input
                label="Email Penanggung Jawab"
                required
                type="email"
                value={data?.email || ''}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                error={StateForm?.errors?.email}
              />

              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Wilayah"
                  placeholder=""
                  url="/region"
                  value={village}
                  initialValue={village?.village_id}
                  params={
                    village && {
                      search: village?.postal_code,
                    }
                  }
                  row={(d) => {
                    return {
                      value: d?.village_id,
                      label: `${d?.village_name}, ${d?.district_name}, ${d?.regency_name}, ${d?.province_name} ${d?.postal_code} `,
                    };
                  }}
                  onSelected={(c) => setVillage(c)}
                  keys={village?.village_id}
                  hint="cari berdasarkan kecamatan/kabupaten/kota/provinsi/kode pos. e.g: 44152"
                  errors={StateForm?.errors?.village_id}
                />
              </div>

              <Form.Textbox
                value={data?.address || ''}
                required
                onChange={(e) => setData({ ...data, address: e.target.value })}
                rows={4}
                label="Alamat"
                error={StateForm?.errors?.address}
              />

              <div className="mt-3">
                <label className="form-label fs-8 required">
                  Logo Perusahaan
                </label>

                <header className="navbar navbar-expand-md navbar-dark d-print-none">
                  <div className="container-xl text-center">
                    <h1
                      className={cn(
                        'navbar-brand d-none-navbar-horizontal cursor-pointer',
                        'navbar-brand-autodark',
                        'text-center centered'
                      )}
                    >
                      <img
                        src={imageEdit ? imageEdit : image}
                        alt=""
                        className="img-fluid text-center rounded-3"
                        style={{ maxHeight: 60, maxWidth: 150 }}
                        id="logo-operator"
                      />
                    </h1>
                  </div>
                </header>

                <div className="d-flex mt-2">
                  {image && (
                    <button
                      type="button"
                      disabled={StateForm?.loading}
                      className="btn btn-xs pe-1 w-50 btn-white"
                      onClick={() => setIsShow(true)}
                    >
                      Edit logo
                    </button>
                  )}

                  <div className="ps-1 w-50 text-center">
                    <input
                      ref={refs}
                      type="file"
                      className={
                        StateForm?.errors?.image
                          ? 'form-control is-invalid'
                          : 'form-control'
                      }
                      multiple={false}
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        imgToBase64(e?.target?.files[0]);
                        setIsShow(true);
                      }}
                      accept="image/png, image/jpeg"
                    />
                    <button
                      type="button"
                      disabled={StateForm?.loading}
                      className={cn(
                        'btn btn-primary  w-100 btn-xs',
                        StateForm?.loading ? 'btn-loading' : null
                      )}
                      onClick={() => {
                        refs.current.click();
                        setCroppedImage(null);
                      }}
                    >
                      Upload Logo
                    </button>
                    <small className="page-pretitle note fw-light text-center">
                      Ukuran maksimal 1MB
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              show={isShow}
              onHide={$handleClose}
              backdrop="static"
              centered
              size="lg"
            >
              <Modal.Body>
                <div className="btn-close" onClick={$handleClose}></div>
                <div className="row mt-3">
                  <div className="col-12 col-md-8 p-3 border rounded">
                    <div className="fw-semibold">Image Editor</div>
                    <div>
                      <div
                        className="position-relative"
                        style={{ height: 150, width: '100%' }}
                      >
                        <Cropper
                          image={image}
                          crop={crop}
                          rotation={rotation}
                          zoom={zoom}
                          aspect={5 / 2}
                          onCropChange={setCrop}
                          onRotationChange={setRotation}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                          // onInteractionEnd={() => showCroppedImage(useBackground)}
                          minZoom={0.4}
                          zoomSpeed={0.3}
                          restrictPosition={false}
                        />
                      </div>

                      <div className="controls-img-editor mt-3">
                        <div className="mb-2 ">
                          <label className="page-pretitle pb-2">
                            Warna Latar
                          </label>
                          <Form.Checkbox
                            value={useBackground}
                            onChange={(e) => {
                              $handleBackground(useBackground ? false : true);
                            }}
                            iconSize={18}
                            label="Tambahkan latar putih"
                          />
                        </div>
                        <div className="mb-2 pb-3 border-bottom">
                          <label className="page-pretitle">Perbesar</label>
                          <input
                            type="range"
                            value={zoom}
                            min={0.4}
                            max={3}
                            step={0.1}
                            aria-labelledby="Zoom"
                            onChange={(e) => {
                              setZoom(e.target.value);
                            }}
                            className="zoom-range"
                          />
                        </div>
                        <div className="mb-2 pb-3 border-bottom">
                          <label className="page-pretitle">Rotasi</label>
                          <input
                            type="range"
                            value={rotation}
                            min={0}
                            max={180}
                            step={10}
                            aria-labelledby="Rotate"
                            onChange={(e) => {
                              setRotation(e.target.value);
                            }}
                            className="zoom-range"
                          />
                        </div>
                        <div className="d-flex align-items-end justify-content-end gap-3">
                          <button
                            type="button"
                            disabled={StateForm?.loading}
                            className={cn(
                              'btn btn-primary',
                              StateForm?.loading ? 'btn-loading' : null
                            )}
                            onClick={() => {
                              showCroppedImage(useBackground);
                            }}
                          >
                            Preview
                          </button>
                          <button
                            type="button"
                            disabled={StateForm?.loading}
                            className={cn(
                              'btn btn-success',
                              StateForm?.loading ? 'btn-loading' : null
                            )}
                            onClick={() => {
                              showCroppedImage(useBackground);
                              setIsShow(false);
                            }}
                          >
                            Simpan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 p-3">
                    <label className="page-pretitle">Preview</label>
                    <header className="navbar navbar-expand-md navbar-dark d-print-none">
                      <div className={'container-xl'}>
                        <h1
                          className={cn(
                            'navbar-brand d-none-navbar-horizontal cursor-pointer',
                            'navbar-brand-autodark'
                          )}
                        >
                          <img
                            src={croppedImage}
                            alt=""
                            className="img-fluid rounded-3"
                            style={{ maxHeight: 60, maxWidth: 150 }}
                            id="logo-operator"
                          />
                        </h1>
                      </div>
                    </header>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </Page.Body>

      <Page.Footer className="padding d-grid gap-2 d-md-flex justify-content-md-end">
        <Button
          type="submit"
          className="btn-primary py-3"
          loading={StateForm?.loading}
        >
          Selanjutnya
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default OnboardingScreen;
